import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { AuditLog } from '@/generated/graphql';
import { createAuditLogTitle } from '@/utils/audit-log.function';

interface AuditHistoryTabProps {
  auditHistory?: AuditLog[];
}

export function AuditHistoryTab({ auditHistory }: AuditHistoryTabProps) {
  return (
    <Card className="relative">
      <CardHeader>
        <CardTitle>Audit History</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid">
          {auditHistory?.map((audit) => {
            return <div key={audit.id}>{createAuditLogTitle(audit)}</div>;
          })}
        </div>
      </CardContent>
    </Card>
  );
}
